enum StaffType {
  Physician = 'Physician',
  Staff = 'OfficeStaff',
}

export default StaffType;
